import tw, { styled } from "twin.macro"

const TabsContainer = styled.div`
  ${tw`bg-gray-50 rounded-md p-5`}
`

export default TabsContainer
